import React from 'react';
import StatusAttDashEnum from 'shared/Enums/StatusAttDashEnum';
import {
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  HourglassEmpty as HourglassEmptyIcon,
  Lock as LockIcon,
  Help as HelpIcon
} from '@mui/icons-material';

export const fraseStatus = (tipo, data) => {
  switch (tipo) {
    case StatusAttDashEnum.FINALIZADO:
    case StatusAttDashEnum.FALHA:
      return `Atualizado em: ${data}`;
    case StatusAttDashEnum.EM_ANDAMENTO:
      return `Iniciado em: ${data}`;
    default:
      return '';
  }
};

export const textoStatus = dadosAtualizacao => {
  const dados = dadosAtualizacao || {};
  const tipo = dados.tipo;
  const descricao = (dados.descricao || '').trim();
  const datePhrase = fraseStatus(tipo, dados.data);
  return { tipo, descricao, datePhrase };
};

export const getStatusIcon = tipo => {
  switch (tipo) {
    case StatusAttDashEnum.FINALIZADO:
      return (
        <CheckCircleIcon className="font-size-15 margin-right-6 items-alinhados-verticalmente texto-success" />
      );
    case StatusAttDashEnum.FALHA:
    case StatusAttDashEnum.ERRO:
      return (
        <CancelIcon className="font-size-15 margin-right-6 items-alinhados-verticalmente texto-danger" />
      );
    case StatusAttDashEnum.EM_ANDAMENTO:
      return (
        <HourglassEmptyIcon className="font-size-15 margin-right-6 items-alinhados-verticalmente texto-warning" />
      );
    case StatusAttDashEnum.DESABILITADO:
      return (
        <LockIcon className="font-size-15 margin-right-6 items-alinhados-verticalmente texto-danger" />
      );
    case StatusAttDashEnum.DESCONHECIDO:
    default:
      return (
        <HelpIcon className="font-size-15 margin-right-6 items-alinhados-verticalmente texto-danger" />
      );
  }
};
